import { useContext } from "react";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";
import { useNavigate } from "react-router-dom";
import EndPointServices from "@services/ApiServices";

export default function useAutenticar() {
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Função auxiliar para verificar e atualizar estado
  function handleVerificar(key, actionType) {
    let value = state[key];
    let resultado = false;

    //Verifica se o state é nulo
    if (!value || Object.keys(value).length === 0) {
      value = UtilServices.getStorage(key);

      //Verifica se storage é nulo
      if (value.length !== 0) {
        dispatch({
          type: actionType,
          payload: value,
        });
        resultado = true;
      }
    } else {
      resultado = true;
    }

    return resultado;
  }

  //Autenticação etapas
  function handleAutenticar() {
    // Etapa 1: Verificar dados do usuário
    const etapa1 = handleVerificar("dadosusuario", "SET_USUARIO");
    if (!etapa1) {
      console.error("Erro na validação dos dados do usuário.");
      return false;
    }
    // Etapa 2: Verificar token
    const etapa3 = UtilServices.verificarToken();
    if (!etapa3) {
      console.error("Token inválido ou expirado.");
      return false;
    }
    //recupera o touclose.
    handleVerificar("tourclose", "SET_TOURCLOSE");

    //recupera o confirmaplano.
    handleVerificar("confirmaplano", "SET_CONFIRMAPLANO");

    //Atualiza o plano novamente.
    handleGetPlan();

    // Todas as etapas passaram
    console.log("Validação concluída com sucesso.");

    return true;
  }

  async function handleGetPlan() {
    let usuario = { ...UtilServices.getStorage("dadosusuario") };

    let data = {
      id_usuario_guid: usuario?.id_usuario_guid,
      id_usuario: usuario?.id_usuario,
    };

    var retornoapi = await EndPointServices.Partilha_PayStatus(data);
    if (retornoapi?.Success) {
      usuario.planos = retornoapi?.BaseReturn?.LstClasse?.filter(
        (item) => item.plano,
      );
      UtilServices.setStorage("dadosusuario", usuario);
      dispatch({
        type: "SET_USUARIO",
        payload: usuario,
      });
    }
  }

  // Remover os estados globais
  function handleLogout(n = "/") {
    dispatch({
      type: "SET_RESET",
    });
    UtilServices.clearStorage();
    navigate(n);
  }

  return { handleAutenticar, handleLogout };
}
